import { TwResponsiveValues, TwSuffix } from "./tw-types";

/**
 * Converts a {@link TwResponsiveValues} prop to a single space-separated
 * class string, suitable for use in `className`.
 */
export const toTwClass = <
  Prefix extends string,
  Suffix extends string = TwSuffix,
>(
  value: TwResponsiveValues<Prefix, Suffix>
): string => (Array.isArray(value) ? value.join(" ") : value);
